import React from 'react';

interface LegalNoticeProps {
  isOpen: boolean;
  onClose: () => void;
}

const LegalNotice: React.FC<LegalNoticeProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold text-gray-800">Aviso Legal</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <i className="fas fa-times text-xl"></i>
          </button>
        </div>
        
        <div className="prose max-w-none">
          <p className="mb-4">
            Este servicio se ofrece sin ningún tipo de garantía. El usuario asume toda la responsabilidad por el uso de esta aplicación.
          </p>
          
          <h3 className="text-lg font-semibold mb-2">Limitación de Responsabilidad</h3>
          <p className="mb-4">
            En ningún caso los desarrolladores o colaboradores de esta aplicación serán responsables por daños directos, indirectos, incidentales, especiales, ejemplares o consecuentes que resulten del uso o la imposibilidad de uso de este servicio.
          </p>
          
          <h3 className="text-lg font-semibold mb-2">Uso del Servicio</h3>
          <p className="mb-4">
            El usuario es responsable de verificar la validez y conformidad de los documentos e-CMR generados con la normativa aplicable. Esta aplicación es una herramienta de apoyo y no sustituye el asesoramiento legal o profesional.
          </p>
          
          <h3 className="text-lg font-semibold mb-2">Almacenamiento de Datos</h3>
          <p>
            Los documentos e-CMR se almacenan localmente en el dispositivo del usuario. Es responsabilidad del usuario realizar copias de seguridad de sus documentos y mantener la seguridad de su dispositivo.
          </p>
        </div>
        
        <div className="mt-6 text-right">
          <button
            onClick={onClose}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice; 